<div class="bg-background min-h-screen w-full font-sans pb-12">
  <div class="max-w-[800px] mx-auto px-4 sm:px-6 md:px-8 pt-8 space-y-6">
    
    <!-- Header -->
    <div class="flex items-center space-x-3 mb-6">
      <!-- Back Button -->
    <button
      type="button"
      class="back-btn"
      (click)="goBack()"
      aria-label="Go back">

      <span class="material-symbols-outlined">
        arrow_back
      </span>

    </button>
      
      <h1 class="font-display font-bold text-2xl text-primary m-0">My Horoscope</h1>
    </div>

    <!-- Alert Messages -->
    <div *ngIf="successMessage" class="bg-green-50 border border-green-200 text-green-800 rounded-xl p-4 flex items-center space-x-3">
      <span class="material-symbols-outlined text-green-500">check_circle</span>
      <span class="text-sm font-medium">{{ successMessage }}</span>
    </div>
    <div *ngIf="errorMessage" class="bg-red-50 border border-red-200 text-red-800 rounded-xl p-4 flex items-center space-x-3">
      <span class="material-symbols-outlined text-red-500">error</span>
      <span class="text-sm font-medium">{{ errorMessage }}</span>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="flex justify-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <ng-container *ngIf="!loading">
      
      <!-- Non-Religious Notice -->
      <div *ngIf="isNonReligiousUser" class="bg-white rounded-3xl p-8 shadow-sm border border-primary/10 text-center space-y-4">
        <div class="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center mx-auto text-emerald-600">
          <span class="material-symbols-outlined text-3xl">public</span>
        </div>
        <h2 class="text-xl font-bold text-neutral-800">Secular / Non-Religious Profile</h2>
        <p class="text-sm text-neutral-600 max-w-lg mx-auto leading-relaxed">
          You have marked your profile as <strong>Non-Religious / Secular</strong>. Astrological charts, horoscopes, and Dosham verifications are hidden and automatically skipped for your profile.
        </p>
        <div class="pt-2">
          <a routerLink="/my-profile" [queryParams]="{tab: 'religion'}" class="inline-flex items-center gap-2 px-5 py-2.5 bg-neutral-100 hover:bg-neutral-200 text-neutral-800 rounded-xl text-sm font-semibold transition-colors">
            <span class="material-symbols-outlined text-[18px]">edit</span> Change Religion Preference
          </a>
        </div>
      </div>

      <ng-container *ngIf="!isNonReligiousUser">
      <!-- Current Horoscope Card -->
      <div class="bg-white rounded-3xl p-6 shadow-sm border border-primary/5" *ngIf="horoscopeData?.url">
        <div class="flex items-start justify-between">
          <div>
            <h2 class="text-lg font-bold text-neutral-800">Current Horoscope</h2>
            <p class="text-xs text-neutral-500 mt-1">Uploaded on {{ horoscopeData.uploadedAt | date:'mediumDate' }}</p>
          </div>
          <button (click)="downloadBiodata()" class="text-primary hover:bg-primary-fixed p-2 rounded-lg flex items-center space-x-2 transition-colors">
            <span class="material-symbols-outlined">download</span>
            <span class="text-sm font-medium">Biodata PDF</span>
          </button>
        </div>

        <div class="mt-4 p-4 border border-neutral-100 rounded-2xl bg-neutral-50 flex items-center space-x-4">
          <div class="h-12 w-12 rounded-xl flex items-center justify-center text-primary" [ngClass]="horoscopeData.type?.includes('pdf') ? 'bg-red-100' : 'bg-blue-100'">
            <span class="material-symbols-outlined">{{ horoscopeData.type?.includes('pdf') ? 'picture_as_pdf' : 'image' }}</span>
          </div>
          <div class="flex-1 truncate">
            <p class="text-sm font-bold text-neutral-800 truncate">{{ horoscopeData.name }}</p>
            <p class="text-xs text-neutral-500">{{ horoscopeData.type }}</p>
          </div>
          <a [href]="viewUrl" target="_blank" class="text-primary hover:underline text-sm font-medium">View File</a>
        </div>
      </div>

      <!-- Upload Form -->
      <div class="bg-white rounded-3xl p-6 shadow-sm border border-primary/5">
        <h2 class="text-lg font-bold text-neutral-800 mb-4">{{ horoscopeData?.url ? 'Replace Horoscope' : 'Upload Horoscope' }}</h2>
        
        <form [formGroup]="horoscopeForm" (ngSubmit)="saveHoroscope()">
          
          <!-- File Upload Area -->
          <div class="mb-6">
            <label class="block text-sm font-medium text-neutral-700 mb-2">Select File (JPG, PNG, PDF max 10MB)</label>
            
            <div *ngIf="!selectedFile" class="border-2 border-dashed border-primary/20 rounded-2xl p-8 text-center hover:bg-primary/5 transition-colors cursor-pointer relative">
              <input type="file" id="horoscopeUpload" (change)="onFileSelected($event)" accept=".jpg,.jpeg,.png,.pdf" class="absolute inset-0 w-full h-full opacity-0 cursor-pointer">
              <span class="material-symbols-outlined text-4xl text-primary/40 mb-2">cloud_upload</span>
              <p class="text-sm font-medium text-primary">Click or drag file to upload</p>
              <p class="text-xs text-neutral-500 mt-1">Supported formats: JPG, PNG, PDF</p>
            </div>

            <div *ngIf="selectedFile" class="p-4 border border-primary/20 rounded-2xl bg-primary/5 flex items-center space-x-4">
              <img *ngIf="previewUrl" [src]="previewUrl" alt="Preview" class="h-16 w-16 object-cover rounded-lg border border-primary/10">
              <div *ngIf="!previewUrl" class="h-16 w-16 rounded-lg bg-neutral-100 flex items-center justify-center text-primary/50">
                <span class="material-symbols-outlined text-2xl">description</span>
              </div>
              <div class="flex-1 truncate">
                <p class="text-sm font-bold text-neutral-800 truncate">{{ selectedFile.name }}</p>
                <p class="text-xs text-neutral-500">{{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB</p>
              </div>
              <button type="button" (click)="removeSelectedFile()" class="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </div>
          </div>

          <!-- Visibility Settings -->
          <div class="mb-8">
            <label class="block text-sm font-medium text-neutral-700 mb-2">Horoscope Visibility</label>
            <p class="text-xs text-neutral-500 mb-3">Control who can view your horoscope and download your Biodata PDF.</p>
            <div class="relative">
              <select formControlName="visibility" class="w-full appearance-none bg-neutral-50 border border-neutral-200 text-neutral-800 text-sm rounded-xl focus:ring-primary focus:border-primary block p-3.5 pr-10 shadow-sm transition-colors">
                <option value="Everyone">Everyone (Public)</option>
                <option value="Accepted Matches Only">Accepted Matches Only (Recommended)</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-neutral-500">
                <span class="material-symbols-outlined text-lg">expand_more</span>
              </div>
            </div>
          </div>

          <!-- Actions -->
          <div class="flex items-center justify-end border-t border-neutral-100 pt-6">
            <button type="submit" [disabled]="saving || (!selectedFile && horoscopeData?.visibility === horoscopeForm.value.visibility)" 
              class="px-6 py-3 bg-primary hover:bg-primary-container text-white rounded-xl text-sm font-bold shadow-md transition-all active:scale-95 flex items-center disabled:opacity-50 disabled:cursor-not-allowed">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
              {{ saving ? 'Saving...' : 'Save Settings' }}
            </button>
          </div>

        </form>
      </div>
      </ng-container>

    </ng-container>
  </div>
</div>
